import { ICmsAcademyItem } from './cms';
import { LegalEntityCountry } from './legal-entity';

// TODO: confirm with the business
export enum CmsAcademyVideosDurations {
  Short = 'Short', // <0, 10)
  Medium = 'Medium', // <10, 60>
  Long = 'Long' // (30, ∞)
}

export enum CmsAcademyVideosSortingModes {
  Date = 'Date',
  Duration = 'Duration',
  Title = 'Title'
}

export interface IAcademyVideosFilters {
  categories?: Array<string>;
  languages?: Array<string>;
  duration?: CmsAcademyVideosDurations;
  sortingMode?: CmsAcademyVideosSortingModes;
}

export interface IAcademyVideosItem extends ICmsAcademyItem {
  duration: number;
  isFeatured: boolean;
  categories: Array<string>;
  videoLanguages: Array<string>;
  additionalAssetsUrl: string;
}

// contentful model
export interface ICmsAcademyVideo {
  id: string;
  title: string;
  description: string;
  videoUrl: string;
  videoThumbnail?: string;
  author: string;
  duration: number;
  videoDate: Date;
  countries: Array<LegalEntityCountry>;
  isFeatured?: boolean;
  categories: Array<string>;
  videoLanguages: Array<string>;
  additionalAssetsUrl: string;
}
